import { TweenMax } from 'gsap';
import { useEffect } from 'react';
import CalculatorModule from '../calculatorModule';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFDelta2Icon1 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon1';
import EFDelta2Icon2 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon2';
import EFDelta2Icon3 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon3';
import EFDelta2Icon4 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon4';
import EFDelta2Icon5 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon5';
import EFDelta2Icon6 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon6';
import EFDelta2Icon7 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon7';
import EFDelta2Icon8 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon8';
import EFDelta2Icon9 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon9';
import EFDelta2Icon10 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon10';
import { createEFPic } from '@/utils/useEFPic';
import EFDelta2Icon10_2 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon10_2';
import EFDelta2Icon6_2 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon6_2';
const { EFPic } = createEFPic('/media/delta2/pc/');

export default function Comp() {
    const { useLang, Link, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const iconInfo = [
        {
            icon: <EFDelta2Icon1 />,
            type: t('delta2.aniF_phone'),
            num: t('delta2.aniF_phone_num'),
            unit: t('delta2.aniF_unit1'),
        },
        {
            icon: <EFDelta2Icon2 />,
            type: t('delta2.aniF_laptop'),
            num: t('delta2.aniF_laptop_num'),
            unit: t('delta2.aniF_unit1'),
        },
        {
            icon: <EFDelta2Icon3 />,
            type: t('delta2.aniF_light'),
            num: t('delta2.aniF_light_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: <EFDelta2Icon4 />,
            type: t('delta2.aniF_wifi'),
            num: t('delta2.aniF_wifi_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: <EFDelta2Icon5 />,
            type: t('delta2.aniF_fan'),
            num: t('delta2.aniF_fan_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: locale === 'ph' ? <EFDelta2Icon6_2 /> : <EFDelta2Icon6 />,
            type: t('delta2.aniF_car'),
            num: t('delta2.aniF_car_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: <EFDelta2Icon7 />,
            type: t('delta2.aniF_tv'),
            num: t('delta2.aniF_tv_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: <EFDelta2Icon8 />,
            type: t('delta2.aniF_refrigerator'),
            num: t('delta2.aniF_refrigerator_num'),
            unit: t('delta2.aniG_msg11'),
        },
        {
            icon: <EFDelta2Icon9 />,
            type: t('delta2.aniF_coffee'),
            num: t('delta2.aniF_coffee_num'),
            unit: t('delta2.aniF_unit2'),
        },
        {
            icon: locale === 'ph' ? <EFDelta2Icon10_2 /> : <EFDelta2Icon10 />,
            type: t('delta2.aniF_grill'),
            num: t('delta2.aniF_grill_num'),
            unit: t('delta2.aniF_unit2'),
        },
    ];

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationF .msg-desc1',
            offset: layoutH * 0.1, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const sceneA2 = new ScrollMagic.Scene({
            triggerElement: '.animationF .top-up',
            offset: layoutH * 0.28, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '20%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationF .msg-desc1',
            0.3,
            {
                opacity: 0,
            },
            {
                opacity: 1,
            },
        );

        const tweenA2 = TweenMax.fromTo(
            '.animationF .top-up',
            0.2,
            {
                y: 50,
                opacity: 0,
                ease: 'none',
            },
            {
                y: 0,
                opacity: 1,
                ease: 'none',
            },
        );

        sceneA1.setTween(tweenA1);
        sceneA2.setTween(tweenA2);
        controllerDelta2?.addScene(sceneA1);
        controllerDelta2?.addScene(sceneA2);
    }, []);

    return (
        <div className={`${css.animationF} animationF GtmModuleData-section`} data-section-id={css.animationF} data-section-title={t('delta2.aniF_msg1')}>
            <div className="static-box">
                <div className="msg-desc1">{t('delta2.aniF_msg1')}</div>
                <div className="msg-desc2">
                    {t.rich('delta2.aniF_msg2', {
                        line1: (text: any) => (
                            <Link className="ef-link__page" href="/x-boost" newWin>
                                {text}
                            </Link>
                        ),
                    })}
                </div>
                <div className="support-types">
                    {iconInfo.map((item, index) => (
                        <div className="type-item" key={index}>
                            <div className="icon">{item.icon}</div>
                            <div className="type">{item.type}</div>
                            <div className="value">
                                <span className="num">{item.num}</span>
                                <span className="unit">{item.unit}</span>
                            </div>
                        </div>
                    ))}
                </div>
                {['cn', 'tw'].includes(locale) && <p className="memo">{t('delta2.aniF_memo')}</p>}
                {['au'].includes(locale) && (
                    <div className="msg-box1">
                        <EFPic name={['animM1.webp', 'animM1.jpg']} />
                        <div className="text-wrapper">
                            <div className="title">{t('delta2.aniM_msg1')}</div>
                            <div className="desc">{t('delta2.aniM_msg2')}</div>
                        </div>
                    </div>
                )}
                {locale === 'za' && <CalculatorModule />}
                <div className="top-up title-bolder">{t('delta2.aniF_msg3')}</div>
            </div>
        </div>
    );
}
